import React from 'react';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as billingActions from '../../redux/billing';
import { HamburgerMenu } from '../Common';
import './Billing.css';

interface Props {
  customer: any;
  billing: any;
  page: string;
  desktop?: boolean;
  openSidebar?: any;
}

const BackButton = styled.img`
  width: 26px;
  height: 26px;
  margin-left: 30px;
  cursor: pointer;
  margin-top: 13px;
`;

class BillingHeader extends React.Component<Props, {}> {
  titles: any = {
    intro: 'PLAN + PAYMENT',
    card: 'ADD CREDIT CARD',
    methods: this.props.customer.subscriptions.total_count ? 'PLAN + PAYMENT' : 'PAYMENT METHOD',
    error: 'ERROR',
  };
  icons: any = {
    intro: <img src="/img/cc.svg" alt="CC" className="cc-card" />,
    card: <img src="/img/cc.svg" alt="CC" className="cc-card" />,
    methods: <img src="/img/cc.svg" alt="CC" className="cc-card" />,
    error: <img src="/img/cc.svg" alt="CC" className="cc-card" />,
  };

  constructor(props: Props) {
    super(props);
    if (this.props.customer.id === undefined) this.props.billing.loadCustomer();
  }

  backLocation() {
    switch (this.props.page) {
      case 'card':
        return '/billing/methods';
      default:
        return '/billing';
    }
  }

  goBack() {
    this.props.billing.changePage(this.backLocation());
  }

  render() {
    if (this.props.desktop) return null;

    return (
      <div className="billingHeader">
        <div className="row">
          <div className="col-2" style={{ marginLeft: '-2%', zIndex: 9999 }}>
            {true && (
              <BackButton src="/img/back-billing.png" alt="Back" onClick={() => this.goBack()} />
            )}
          </div>
          <div className="col billingTitle" style={{ marginLeft: '2%', marginTop: '15px' }}>
            {this.props.customer.email
              ? this.props.desktop
                ? ''
                : this.titles[this.props.page]
              : 'Loading...'}
          </div>
          <div className="col-2" style={{ marginTop: '5px', zIndex: 9999 }}>
            <HamburgerMenu onClick={() => this.props.openSidebar()} />
          </div>
        </div>
        {!this.props.desktop && this.icons[this.props.page]}
        <br />
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    customer: state.billing.customer,
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    billing: bindActionCreators(billingActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BillingHeader);
